import React, { Fragment } from 'react';
import PointContent from '../../components/account/PointContent';
import TitleBox from '../../components/common/TitleBox';

const Point = () => {
    return (
        <Fragment>
            <TitleBox title="포인트전환"/>
            <div className="contents_wrap">
                <PointContent />
            </div>
        </Fragment>
    );
};

export default Point;


// WEBPACK FOOTER //
// ./src/containers/Account/Point.js